"use client";

import "./globals.css";
import { StripePublishableKeyProvider } from "@/lib/StripePublishableKeyProvider";
import { StripeReaderProvider } from "@/lib/providers/StripeReaderProvider";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
// TODO - Add back in when we release translations
import { useState } from "react";

export default function AppWrappers({
  publicEnvVariables,
  children,
}: {
  publicEnvVariables: {
    stripePublishableKey: string;
  };
  children: React.ReactNode;
}) {
  const [queryClient] = useState(new QueryClient());
  const { stripePublishableKey } = publicEnvVariables;

  return (
    <StripePublishableKeyProvider stripePublishableKey={stripePublishableKey}>
      <StripeReaderProvider>
        <QueryClientProvider client={queryClient}>
          {process.env.NODE_ENV === "development" && (
            <ReactQueryDevtools
              initialIsOpen={false}
              buttonPosition="top-right"
            />
          )}
          {/* <ReactScan /> */}
          {children}
        </QueryClientProvider>
      </StripeReaderProvider>
    </StripePublishableKeyProvider>
  );
}
